<template>
    <div v-show="show" class="interviewTable-container">
        <div class="interviewTableContent">
            <div class="top">
                <div class="title">{{title}}</div>
                <p>
                    <img src="./assets/notice.png" alt="">
                    <span>仅保存{{day}}天记录</span>
                </p>
            </div>
            <div v-show="config != 'log'" :class="{titleline: true, record: true}">
                <span class="title">设备名称</span>
                <span class="num">编号</span>
                <span class="reporter">记者</span>
                <span class="endTime">到期时间</span>
                <span class="backTime">归还时间</span>
                <span class="backer">归还确认人</span>
                <span class="handles">归还操作</span>
            </div>
            <div v-show="config == 'log'" :class="{titleline: true, record: true}">
                <span class="title">设备名称</span>
                <span class="num">编号</span>
                <span class="reporter1">分类</span>
                <span class="reporter1">操作人</span>
                <span class="reporter1">执行操作</span>
                <span class="endTime1">操作时间</span>
            </div>
            <empty :mTop="50" :msg="'暂无数据'" v-if="list && list.length === 0" />
            <div ref="list" class="itemsList" @scroll="getScroll($event)">
                <template v-if="config != 'log'">
                    <div class="items" v-for="(resource,index) in list" :key="index">
                        <div :class="{item: true, record: true}">
                            <div class="title">
                                {{resource.device_title}}
                            </div>
                            <div class="num">
                                {{resource.idstring}}
                            </div>
                            <div class="statusType">
                                {{resource.using_user}}
                            </div>
                            <div class="endTime">
                                {{resource.end_time}}
                            </div>
                            <div class="backTime">
                                {{resource.return_submit_time}}
                            </div>
                            <div class="backer">
                                {{resource.opt_username}}
                            </div>
                            <div class="handles">
                                {{resource.opt_type}}
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="config == 'log'">
                    <div class="items" v-for="(resource,index) in list" :key="index">
                        <div :class="{item: true, record: true}">
                            <div class="title">
                                {{resource.title}}
                            </div>
                            <div class="num">
                                {{resource.idstring}}
                            </div>
                            <div class="reporter1">
                                {{resource.type_title}}
                            </div>
                            <div class="reporter1">
                                {{resource.truename}}
                            </div>
                            <div class="reporter1">
                                {{resource.opt_type}}
                            </div>
                            <div class="endTime1">
                                {{resource.raw_add_time}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
    components: {
        empty
    },
    watch: {
        value1(to) {
            console.log(to)
        }
    },
    data() {
        return {
            resources: [],
            show: false,
            config: {},
            callback: null,
            title: '操作记录',
            value1: '',
            allLoaded: false,
            page: {
                page_count: 0,
                pageSize: 10,
                pageIndex: 1,
                total: 0
            },
            list: [],
            day: 0
        }
    },
    methods: {
        async getScroll(e) {
            if (e) {
                let containerH = 420;
                let scrollTop = e.target.scrollTop;
                let listHeight = this.$refs.list.offsetHeight;
                console.log("getScroll");
                if (scrollTop + containerH >= listHeight) {
                    if (this.allLoaded) {
                        console.log("进入allLoaded分支");
                        return e.preventDefault();
                    } else {
                        console.log("getScroll 拿分页");
                        this.page.pageIndex ++
                        this.getList();
                    }
                }
            }
        },
        open(config, callback) {
            this.page.pageIndex = 1
            if(config == 'log'){
                this.title = '操作日志'
            }else{
                this.title = '操作记录'
            }
            this.config = config;
            this.getList()
            this.callback = callback;
            this.show = true;
        },
        getList() {
            this.allLoaded = true;
            const info = {
                page: this.page.pageIndex,
                pagesize: this.page.pageSize
            }

            console.log(this.config)

            if(this.config == 'log'){
                common.myFetch(apis.optlogs, info)
                .then((r) => {
                    if (r) {
                        this.day = r.days
                        if(this.page.pageIndex == 1){
                            this.list = r.list
                        }else{
                            this.list = this.list.concat(r.list)
                        }
                        
                        this.allLoaded = false;
                        // console.log(r)
                    }
                })
            }else{
                common.myFetch(apis.Return_optlog, info)
                .then((r) => {
                    if (r) {
                        this.day = r.days
                        this.list = r.list
                        console.log(r)
                    }
                })
            }
        },
        confirm() {
            
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        }
    }
}
</script>
<style src="./assets/index.less" lang="less" scoped>

</style>
<style lang="less">
.el-button--text {
    color: #41B48C !important;

    &:hover {
        color: #41B48C !important;
    }
}

.el-button.is-plain:focus, .el-button.is-plain:hover {
    color: #41B48C !important;
    border-color: #41B48C !important;
}
</style>